var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58557",
    "data-name": "Group 58557",
    transform: "translate(6360 19299)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13821",
    "data-name": "Rectangle 13821",
    width: 16,
    height: 16,
    transform: "translate(-6360 -19299)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-home",
    "data-name": "Icon ionic-md-home",
    d: "M8.76,16.5v-4H11.99v4h3.285v-6h2.1l-7-6-7,6h2.1v6Z",
    transform: "translate(-6362.375 -19302.5)",
    fill: "none",
    stroke: "#606060",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.d19833dffba5ee93b3a62da7ac8a4e65.svg";
export { ForwardRef as ReactComponent };